// Module
var code = "<span class=\"label\" ng-if=\"!$ctrl.hideIfZero || $ctrl.count > 0\" ng-class=\"$ctrl.count > 0 ? 'label-danger' : 'label-default'\" ui-sref=\"developer.qbSyncStatus({filter:$ctrl.guid})\">{{$ctrl.count}} {{$ctrl.caption || 'pending'}}</span>";
// Exports
module.exports = code;